import React, { createContext, useContext, useEffect, useState } from "react";

const CurrencyCtx = createContext(null);

// Local fallback — will be replaced by /api/fx/rates on load
const FALLBACK = {
  base: "USD",
  rates: { USD: 1.0, EUR: 0.92, GBP: 0.79, INR: 83.15, AED: 3.67, SGD: 1.35, CHF: 0.88 },
  symbols: { USD: "$", EUR: "€", GBP: "£", INR: "₹", AED: "د.إ", SGD: "S$", CHF: "CHF " },
};

const SUPPORTED = ["USD", "EUR", "GBP", "INR", "AED", "SGD", "CHF"];

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("artha_currency") : null;
    return SUPPORTED.includes(saved) ? saved : "USD";
  });
  const [fx, setFx] = useState(FALLBACK);

  useEffect(() => {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    fetch(`${BACKEND_URL}/api/fx/rates`).then((r) => r.json()).then(setFx).catch(() => {});
  }, []);

  useEffect(() => {
    localStorage.setItem("artha_currency", currency);
  }, [currency]);

  const convert = (usd) => {
    const rate = fx.rates?.[currency] ?? 1;
    const v = Number(usd) * rate;
    return currency === "INR" ? Math.round(v) : Math.round(v * 100) / 100;
  };

  const format = (usd, opts = {}) => {
    const amt = convert(usd);
    const sym = fx.symbols?.[currency] || "$";
    const digits = currency === "INR" ? 0 : (opts.decimals ?? 0);
    const formatted = amt.toLocaleString(undefined, {
      minimumFractionDigits: digits, maximumFractionDigits: digits,
    });
    return `${sym}${formatted}`;
  };

  return (
    <CurrencyCtx.Provider value={{ currency, setCurrency, fx, convert, format, supported: SUPPORTED }}>
      {children}
    </CurrencyCtx.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyCtx);
